import React from 'react';
import PropTypes from 'prop-types';
import { US, GB } from 'country-flag-icons/react/3x2';
import { getCountryDisplayLabel } from 'utils';

const FLAG_MAP = { US, GB };

const CountryFlag = ({ code, showLabel = false, ...rest }) => {
  const Flag = FLAG_MAP[code];
  const flagEl = Flag ? <Flag style={{ width: 24, height: 16 }} {...rest} /> : null;
  if (showLabel) {
    return (
      <>
        {flagEl}
        <div>{getCountryDisplayLabel(code)}</div>
      </>
    );
  }
  return flagEl;
};

CountryFlag.propTypes = {
  code: PropTypes.string.isRequired,
  showLabel: PropTypes.bool,
};

export default CountryFlag;
